import AssessmentIntroductionDisplay from './AssessmentQuestionDisplay';

export default AssessmentIntroductionDisplay;
